"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const GuidelinesIcon = createIcon({
  displayName: "GuidelinesIcon",
  viewBox: "0 0 33 45",
  path: (
    <>
      <path
        d="M16.5,45c-.99,0-1.88-.23-2.67-.7-.8-.47-1.42-1.1-1.88-1.88-1.25,0-2.32-.44-3.21-1.32-.89-.88-1.34-1.94-1.34-3.18v-7.99c-2.24-1.46-4.03-3.39-5.38-5.79-1.35-2.4-2.02-5.01-2.02-7.82C0,11.77,1.6,7.92,4.81,4.75,8.01,1.58,11.91,0,16.5,0s8.49,1.58,11.69,4.75c3.21,3.17,4.81,7.02,4.81,11.56,0,2.89-.67,5.51-2.02,7.88-1.35,2.36-3.14,4.27-5.38,5.74v7.99c0,1.24-.45,2.3-1.34,3.18-.89.88-1.96,1.32-3.21,1.32-.46.79-1.08,1.42-1.88,1.88-.8.47-1.69.7-2.67.7ZM11.95,37.91h9.1v-2.02h-9.1v2.02ZM11.95,33.64h9.1v-2.14h-9.1v2.14ZM11.49,27h3.3v-6.08l-5.01-4.95,2.39-2.36,4.32,4.28,4.32-4.28,2.39,2.36-5.01,4.95v6.08h3.3c2.05-.98,3.72-2.41,5.01-4.3,1.29-1.89,1.93-4.02,1.93-6.38,0-3.3-1.16-6.09-3.47-8.38-2.31-2.29-5.14-3.43-8.48-3.43s-6.16,1.14-8.48,3.43c-2.31,2.29-3.47,5.08-3.47,8.38,0,2.36.64,4.49,1.93,6.38,1.29,1.89,2.96,3.33,5.01,4.3Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default GuidelinesIcon;
